import { CacheCoordinates } from "./cacheCoordinates.class";

export class CacheLocation extends CacheCoordinates
{
    public ServiceOrderId: number;

     constructor (obj:CacheLocation)
         {
            super(obj.Latitude, obj.Longitude, obj.TimeStamp);
            this.ServiceOrderId = obj.ServiceOrderId;
         }
}
